<script setup>
import { Link, useForm } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import BookingSubMenu from '@/Includes/BookingSubMenu.vue';
import { ref, onMounted } from "vue";
import { useToast } from 'vue-toast-notification';
import Loading from 'vue-loading-overlay';
import { Modal } from 'bootstrap';
import FlatPickr from 'vue-flatpickr-component';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

const props = defineProps({
    year: String,
    invoices: Object,
    taxinvoices: Object,
    bookingById: Object,
    flash: Object,
    user: Object,
});

const $toast = useToast();
let isLoading = ref(false);
let modalShow = ref(null);
let thisModalObj = null;
let menu = 'accounts';
dayjs.extend(advancedFormat);

const configArrv = ref({
    altFormat: 'J M, Y',
    altInput: true,
    dateFormat: 'Y-m-d',
    minDate: "today"
});

onMounted(() => {
    thisModalObj = new Modal(modalShow.value);

    const readonlyInput = document.querySelectorAll('input[readonly]');
    readonlyInput.forEach((item) => {
        item.style.backgroundColor = '#eceef14a';
    });
});

//currency formatter
function formatPrice(value) {
    let val = (value / 1).toFixed(2).replace('.', '.');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const InvoiceAddform = useForm({
    invdetails: [],
    payment_due: '',
    currency: '',
    booking_id: props.bookingById.id,
    remarks: '',
    booking_no: props.bookingById.booking_no,
});

const InvoiceAddformSubmit = () => {
    InvoiceAddform.post('/invoices/store', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide()
            $toast.open({
                message: props.flash.message,
                type: "info",
                duration: 4000,
                position: 'top-right',
                class: 'bs-toast toast bg-dark show'
            });
        }
    });
};

const TaxInvoiceAddform = useForm({
    room_rate: '0',
    total_payable: '0',
    currency: '',
    tcs: '',
    booking_id: props.bookingById.id,
});

const TaxInvoiceAddformSubmit = () => {
    TaxInvoiceAddform.post('/taxinvoices/store', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide()
            $toast.open({
                message: props.flash.message,
                type: "info",
                duration: 4000,
                position: 'top-right',
                class: 'bs-toast toast bg-dark show'
            });
        }
    });
};

//setting up the invoice details
InvoiceAddform.invdetails = [];
for (let i = 0; i < props.bookingById.booking_rooms.length; i++) {
    InvoiceAddform.invdetails.push({
        qty: props.bookingById.booking_rooms[i].nights,
        description: props.bookingById.booking_rooms[i].room_category?.name + ' for ' + props.bookingById.booking_rooms[i].nights + ' nights',
        rate: 0,
        amount: 0,
    });
}

//updating invoice total
function handleRateChange(index, params) {

    console.log(params.target.value);
    InvoiceAddform.invdetails[index].amount = formatPrice(params.target.value * InvoiceAddform.invdetails[index].qty);

    let total = 0;
    for (let i = 0; i < InvoiceAddform.invdetails.length; i++) {
        total += parseFloat(InvoiceAddform.invdetails[i].qty * InvoiceAddform.invdetails[i].rate);
    }
    InvoiceAddform.totalamount = formatPrice(total);
}

function handleQtyChange(index, val) {

    console.log(val.target.value);

    InvoiceAddform.invdetails[index].amount = formatPrice(val.target.value * InvoiceAddform.invdetails[index].rate);

    //total amount calculation
    let total = 0;
    for (let i = 0; i < InvoiceAddform.invdetails.length; i++) {
        total += parseFloat(InvoiceAddform.invdetails[i].qty * InvoiceAddform.invdetails[i].rate);
    }
    InvoiceAddform.totalamount = formatPrice(total);
}

function addFormRow(params) {
    InvoiceAddform.invdetails.push({
        qty: 0,
        description: '',
        rate: 0,
        amount: 0,
    });
}

function removeFormRow(index) {
    InvoiceAddform.invdetails.splice(index, 1);
}

function deleteInvoice(value) {
    new Swal({
        title: 'Are you sure?',
        text: "All the data related to this invoice will be deleted!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'I am sure!'
    }).then((result) => {
        if (result.isConfirmed) {
            setTimeout(() => {
                window.location.href = '/invoices/delete/' + value;
            }, 300);

            $toast.success('Invoice deleted successfully!', {
                position: 'top-right',
                duration: 4000,
                hideProgressBar: true,
                icon: true,
                type: "info",
                class: 'bs-toast toast bg-dark show'
            });
        }
    })
}

function deleteTaxInvoice(value) {
    new Swal({
        title: 'Are you sure?',
        text: "All the data related to this invoice will be deleted!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'I am sure!'
    }).then((result) => {
        if (result.isConfirmed) {
            setTimeout(() => {
                window.location.href = '/taxinvoices/delete/' + value;
            }, 300);

            $toast.success('Invoice deleted successfully!', {
                position: 'top-right',
                duration: 4000,
                hideProgressBar: true,
                icon: true,
                type: "info",
                class: 'bs-toast toast bg-dark show'
            });
        }
    })
}

//invoice total amount
function invoiceAmount(value) {
    let total = 0;
    value.forEach(element => {
        total += parseFloat(element.amount);
    });
    return total;
}

function FormReset() {
    InvoiceAddform.clearErrors();
    thisModalObj.hide();
}
</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import 'flatpickr/dist/themes/material_orange.css';
@import "vue-loading-overlay/dist/vue-loading.css";
</style>
<template>
    <AppLayout title="Hotel Manager" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <BookingSubMenu :bookingById="bookingById" :invoices="invoices" :menu="menu" />
            <div class="card mb-4">
                <div class="card-datatable table-responsive">
                    <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper dt-bootstrap5 no-footer">
                        <div class="card-header flex-column flex-md-row">
                            <div class="head-label text-center">
                                <h5 class="card-title mb-0">Proforma Invoice</h5>
                            </div>
                        </div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Invoice #</th>
                                    <th>Created On</th>
                                    <th>Payment Deadline</th>
                                    <th>Amount</th>
                                    <th>Type</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody class="table-border-bottom-0">
                                <tr v-for="invoice in props.invoices" :key="invoice.id">
                                    <td><i class="fab fa-angular fa-lg text-danger me-3"></i> <strong>
                                            {{ invoice.invoice_no }}</strong>
                                    </td>
                                    <td>{{ dayjs(invoice.created_at).format('Do MMMM, YYYY - H:mm') }}</td>
                                    <td>
                                        {{ dayjs(invoice.payment_due).format('Do MMMM, YYYY') }}
                                    </td>
                                    <td>
                                        <b>{{ invoice.currency }}</b>
                                        {{ formatPrice(invoiceAmount(invoice.invoicedetails)) }}
                                    </td>

                                    <td>{{ invoice.type }}</td>
                                    <td>
                                        <span v-if="invoice.paid_date" class="badge bg-success me-1">Payment
                                            Received</span>
                                        <span v-else="invoice.paid_date" class="badge bg-danger me-1">Payment
                                            Pending</span>
                                    </td>

                                    <td>
                                        <div class="dropdown">
                                            <button type="button" class="btn p-0 dropdown-toggle hide-arrow"
                                                data-bs-toggle="dropdown">
                                                <i class="bx bx-dots-vertical-rounded"></i>
                                            </button>
                                            <div class="dropdown-menu">
                                                <Link class="dropdown-item" :href="'/invoices/preview/' + invoice.id"
                                                    href="#"
                                                    v-if="$page.props.user.permissions.includes('preview-proforma-invoice')">
                                                <i class="bx bx-search-alt me-1"></i>
                                                Preview Invoice</Link>
                                                <Link
                                                    v-if="bookingById.status != 'Paid' && $page.props.user.permissions.includes('remove-proforma-invoice')"
                                                    class="dropdown-item" href="#" preserveScroll
                                                    @click="deleteInvoice(invoice.id)"><i class="bx bx-trash me-1"></i>
                                                Delete</Link>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="card" v-if="taxinvoices.length > 0">
                <div class="card-datatable table-responsive">
                    <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper dt-bootstrap5 no-footer">
                        <div class="card-header flex-column flex-md-row">
                            <div class="head-label text-center">
                                <h5 class="card-title mb-0">Tax Invoice</h5>
                            </div>
                        </div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Invoice #</th>
                                    <th>Created On</th>
                                    <th>Room Rate</th>
                                    <th>Payable</th>
                                    <th>Currency</th>
                                    <th>Type</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody class="table-border-bottom-0">
                                <tr v-for="taxinvoice in props.taxinvoices" :key="taxinvoice.id">
                                    <td><i class="fab fa-angular fa-lg text-danger me-3"></i> <strong>
                                            {{ taxinvoice.invoice_no }}</strong>
                                    </td>
                                    <td>{{ dayjs(taxinvoice.created_at).format('Do MMMM, YYYY - H:mm') }}</td>
                                    <td>
                                        {{ formatPrice(taxinvoice.room_rate) }}
                                    </td>
                                    <td>
                                        {{ formatPrice(taxinvoice.total_payable) }}
                                    </td>
                                    <td>{{ taxinvoice.currency }}</td>
                                    <td>{{ taxinvoice.type }}</td>
                                    <td>
                                        <div class="dropdown">
                                            <button type="button" class="btn p-0 dropdown-toggle hide-arrow"
                                                data-bs-toggle="dropdown">
                                                <i class="bx bx-dots-vertical-rounded"></i>
                                            </button>
                                            <div class="dropdown-menu">
                                                <Link class="dropdown-item"
                                                    v-if="$page.props.user.permissions.includes('view-tax-invoice')"
                                                    :href="'/taxinvoices/preview/' + taxinvoice.id">
                                                <i class="bx bx-search-alt me-1"></i>
                                                Preview Invoice</Link>
                                                <Link class="dropdown-item"
                                                    v-if="$page.props.user.permissions.includes('remove-tax-invoice')"
                                                    preserveScroll @click="deleteTaxInvoice(taxinvoice.id)" href="#"><i
                                                    class="bx bx-trash me-1"></i> Delete</Link>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="addInvoiceModal" tabindex="-1" aria-modal="true" role="dialog" ref="modalShow">
            <div class="modal-dialog modal-xl modal-dialog-top">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create Proforma Invoice</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="InvoiceAddformSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Qty</th>
                                                <th>Description</th>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(details, index) in InvoiceAddform.invdetails" :key="details.id">
                                                <td class="col-md-2">
                                                    <input type="number" v-model="details.qty" class="form-control" min="1"
                                                        step="1" required="required"
                                                        @change="handleQtyChange(index, $event)">
                                                </td>
                                                <td class="col-md-5">
                                                    <input type="text" v-model="details.description" class="form-control"
                                                        placeholder="Description" required="required">
                                                </td>
                                                <td class="col-md-2">
                                                    <input type="number" step="0.01" v-model="details.rate"
                                                        class="form-control" placeholder="Rate" required="required"
                                                        @change="handleRateChange(index, $event)">
                                                </td>
                                                <td class="col-md-3">
                                                    <input type="text" v-model="details.amount" class="form-control"
                                                        placeholder="Amount" required="required" disabled>
                                                </td>
                                                <td>
                                                    <button v-if="bookingById.stay_type == 1 && index !== 0 && index !== 1"
                                                        type="button" class="btn btn-danger" @click="removeFormRow(index)">
                                                        <i class="bx bx-trash"></i>
                                                    </button>
                                                    <button v-if="bookingById.stay_type == 0 && index !== 0" type="button"
                                                        class="btn btn-danger" @click="removeFormRow(index)">
                                                        <i class="bx bx-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2" class="align-top px-4 py-5">
                                                    <div class="mb-2 col-md-6">
                                                        <label for="payment_due" class="form-label text-danger"><b>Payment
                                                                Deadline</b></label>
                                                        <FlatPickr v-model="InvoiceAddform.payment_due" :config="configArrv"
                                                            class="form-control" placeholder="Select Payment Due Date"
                                                            name="payment_due"
                                                            :class="{ 'is-invalid': InvoiceAddform.errors.payment_due }" />
                                                        <div v-if="InvoiceAddform.errors.payment_due"
                                                            class="invalid-feedback">
                                                            <div v-text="InvoiceAddform.errors.payment_due">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="text-end px-4 py-5">
                                                    <p class="mb-2">
                                                        <label for="currency" class="form-label"><b>Currency</b></label>
                                                        <select class="form-select" name="currency"
                                                            v-model="InvoiceAddform.currency"
                                                            :class="{ 'is-invalid': InvoiceAddform.errors.currency }">
                                                            <option value="" disabled selected>Select Currency</option>
                                                            <option value="USD">USD</option>
                                                            <option value="INR">INR</option>
                                                            <option value="AED">AED</option>
                                                        </select>
                                                    <div v-if="InvoiceAddform.errors.currency" class="invalid-feedback">
                                                        <div v-text="InvoiceAddform.errors.currency">
                                                        </div>
                                                    </div>
                                                    </p>
                                                </td>
                                                <td class="px-4 py-5">
                                                    <p class="fw-semibold mb-2">
                                                        <label for="totalamount" class="form-label"><b>Total</b></label>
                                                        <input type="text" class="form-control"
                                                            v-model="InvoiceAddform.totalamount" readonly="readonly">
                                                    </p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="col-md-12">
                                        <textarea class="form-control" name="remarks" v-model="InvoiceAddform.remarks"
                                            rows="3" placeholder="Remarks"></textarea>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button id="addRow" type="button" class="btn btn-outline-warning" @click="addFormRow()">Add
                                Row</button>
                            <button type="button" class="btn btn-label-secondary" @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Create Invoice</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal fade" id="addTaxInvoiceModal" tabindex="-1" aria-modal="true" role="dialog" ref="modalShow">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create Tax Invoice</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="TaxInvoiceAddformSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-5">
                                    <label for="rate" class="form-label"><b>Room Rate</b></label>
                                    <input type="number" name="room_rate" class="form-control"
                                        v-model="TaxInvoiceAddform.room_rate" placeholder="Room Rate" required="required">
                                </div>
                                <div class="col-md-5">
                                    <label for="total_payable" class="form-label"><b>Total Amount Payable</b></label>
                                    <input type="number" name="total_payable" class="form-control"
                                        placeholder="Total Amount Payable" v-model="TaxInvoiceAddform.total_payable"
                                        required="required">
                                </div>
                                <div class="col-md-2">
                                    <label for="currency" class="form-label"><b>Currency</b></label>
                                    <select class="form-select" name="currency" v-model="TaxInvoiceAddform.currency"
                                        required>
                                        <option value="" selected disabled>Select Currency ...</option>
                                        <option value="INR">INR</option>
                                        <option value="USD">USD</option>
                                        <option value="AED">AED</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-2 form-check form-check-primary mt-3" style="padding-left: 36px;">
                                    <input class="form-check-input" type="checkbox" value="1" name="tcs"
                                        v-model="TaxInvoiceAddform.tcs">
                                    <label class="form-label" for="customCheckPrimary">TCS Invoice</label>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-label-secondary" @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Create Invoice</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </AppLayout>
</template>